var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51304 12.8H1.59953L5.77249 11.8919C5.85377 11.8783 5.92909 11.8407 5.98869 11.7838L13.0589 4.71355C13.5754 4.19818 13.8635 3.49721 13.8589 2.76763C13.8598 2.03239 13.5726 1.32607 13.0589 0.800073C12.5435 0.28359 11.8426 -0.0045722 11.113 0.000104291C10.3787 -0.00639313 9.67442 0.290957 9.16704 0.821718L2.11842 7.8919C2.05626 7.94194 2.01094 8.00985 1.98868 8.0865L1.08061 12.2595C1.05582 12.4093 1.10399 12.5619 1.21035 12.6703C1.29018 12.7517 1.39898 12.7984 1.51304 12.8ZM11.113 0.864965C12.1518 0.864882 12.9941 1.70702 12.9941 2.74591C12.9941 2.75315 12.9941 2.76039 12.994 2.76763C13.0011 3.26255 12.8058 3.73894 12.4535 4.08653L9.79406 1.40545C10.1444 1.05728 10.619 0.862771 11.113 0.864965ZM9.18865 2.03251L11.8481 4.69195L5.68596 10.8324L3.02652 8.19459L9.18865 2.03251ZM2.68059 9.05949L4.8211 11.2L2.07517 11.8054L2.68059 9.05949Z",
    fill: "#B91718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.243 15.1348H0.756649C0.517817 15.1348 0.324219 15.3284 0.324219 15.5672C0.324219 15.806 0.517817 15.9996 0.756649 15.9996H15.243C15.4819 15.9996 15.6755 15.806 15.6755 15.5672C15.6755 15.3284 15.4819 15.1348 15.243 15.1348Z",
    fill: "#B91718"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.59db3f6c05576a04f816626878370352.svg";
export { ForwardRef as ReactComponent };